import { Pipe, PipeTransform } from '@angular/core';
import { Status } from './itineray.model';

@Pipe({
  name: 'itineraryStatusColor'
})
export class ItineraryStatusColorPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const status: Status = value;
    switch (status) {
      case Status.TODO: return "rgb(3, 169, 244);";
      case Status.IN_PROGRESS: return "rgb(255, 160, 0)";
      case Status.PROCESSING: return "rgb(158, 158, 158)";
      case Status.IN_REVIEW: return "rgb(158, 158, 158)";
      case Status.DONE: return "rgb(76, 175, 80)";
    }
  }

}
